import { memo } from 'react';

import { DefaultNoWorkspaceContentState } from '~/components/AllContent/DefaultNoWorkspaceContentState';
import { useCanShowBoardsInAllContent } from '~/components/AllContent/hooks/useCanShowBoardsInAllContent';
import { PrivateTableView, type PrivateTableViewProps } from '~/components/TableView/PrivateTableView';
import { PrivateAssetTableRow } from '~/components/TableView/PrivateTableView/PrivateAssetTableRow';
import { PrivateBoardTableRow } from '~/components/TableView/PrivateTableView/PrivateBoardTableRow';

export type SearchPageTableViewProps = {
  scrollElementRef: PrivateTableViewProps['scrollElementRef'];
};

export const SearchPageTableView = memo(({ scrollElementRef }: SearchPageTableViewProps) => {
  const { canShowBoards } = useCanShowBoardsInAllContent();

  return (
    <PrivateTableView
      EmptyState={DefaultNoWorkspaceContentState}
      scrollElementRef={scrollElementRef}
      renderBoardRow={({ data, key, rowStyle }) => <PrivateBoardTableRow key={key} data={data} style={rowStyle} />}
      renderAssetRow={({ data, key, rowStyle }) => <PrivateAssetTableRow key={key} data={data} style={rowStyle} />}
      showBoards={canShowBoards}
    />
  );
});

SearchPageTableView.displayName = 'SearchPageTableView';
